import styled from '@emotion/styled'
import SVGLoader from '@src/components/svg/SVGLoader'
import { IMG_STORAGE_URL } from '@src/utils/constants'

type SideBarProfileProps = {
	profileImg?: string | null
	username: string
}

const SideBarProfile = ({ profileImg, username }: SideBarProfileProps) => {
	return (
		<ProfileBlock>
			<ImgBlock>
				{profileImg ? (
					<ProfileImg
						src={`${IMG_STORAGE_URL}/commerce/vendor/profile_img/${profileImg}`}
						alt={`profile-img-${username}`}
					/>
				) : null}
			</ImgBlock>
			<ProfileRight>
				<ProfileName>{username}</ProfileName>
				<LinkWrapper
					onClick={() =>
						window.open(
							`https://preview.motiners.com?path=${username}${
								process.env.NODE_ENV !== 'production' ? '&qa=1' : ''
							}`,
							'_blank',
						)
					}
				>
					<LinkText>브랜드 페이지</LinkText>
					<SVGLoader name="rightArrow" />
				</LinkWrapper>
			</ProfileRight>
		</ProfileBlock>
	)
}

const ProfileBlock = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	margin-bottom: 3rem;
`

const ImgBlock = styled.div`
	border-radius: 50%;
	width: 6.4rem;
	height: 6.4rem;
	overflow: hidden;
`

const ProfileImg = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`

const ProfileRight = styled.div`
	display: flex;
	flex-direction: column;
	gap: 7px;
`

const ProfileName = styled.span`
	font-size: 1.6rem;
	font-weight: 700;
	line-height: 1.9rem;
	margin-left: 2.9rem;
`

const LinkWrapper = styled.div`
	border: 1px solid #d9d9d9;
	border-radius: 24px;
	background: #4e4e4e;
	padding: 10px;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 7px;
	margin-left: 19px;
	cursor: pointer;

	& svg {
		color: #ffffff;
	}
`

const LinkText = styled.div`
	color: #4e4e4e;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	color: #ffffff;
`

export default SideBarProfile
